/**
 * Generated from ch8_p04.fla
 */
export function ch8_p04(this: Ich8_p04) {
	const bg = this.bg;
	ch8_p04_hh_ch8_72dpi_p04psdAssetbg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const trunk = this.trunk;
	ch8_p04_hh_ch8_72dpi_p04psdAssettrunk.call(this.trunk);
	trunk.x = 633.25;
	trunk.y = 384;
	trunk.width = 940.50;
	trunk.height = 768.00;
	trunk.alpha = 1.00;
	if (trunk.onLayout) trunk.onLayout();
	const foliage = this.foliage;
	ch8_p04_hh_ch8_72dpi_p04psdAssetfoliage.call(this.foliage);
	foliage.x = 628.5;
	foliage.y = 73.75;
	foliage.width = 1257.00;
	foliage.height = 147.50;
	foliage.alpha = 1.00;
	if (foliage.onLayout) foliage.onLayout();
	const lamb = this.lamb;
	ch8_p04_hh_ch8_72dpi_p04psdAssetlamb.call(this.lamb);
	lamb.x = 951.75;
	lamb.y = 369.75;
	lamb.width = 1051.50;
	lamb.height = 735.50;
	lamb.alpha = 1.00;
	if (lamb.onLayout) lamb.onLayout();
	const frameRight = this.frameRight;
	ch8_p04_hh_ch8_72dpi_p04psdAssetframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch8_p04_hh_ch8_72dpi_p04psdAssetframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssetbg(this: Ich8_p04_hh_ch8_72dpi_p04psdAssetbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssettrunk(this: Ich8_p04_hh_ch8_72dpi_p04psdAssettrunk) {
	if (this.setLayoutTexture) this.setLayoutTexture("trunk", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssetfoliage(this: Ich8_p04_hh_ch8_72dpi_p04psdAssetfoliage) {
	if (this.setLayoutTexture) this.setLayoutTexture("foliage", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssetlamb(this: Ich8_p04_hh_ch8_72dpi_p04psdAssetlamb) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamb", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssetframeRframe(this: Ich8_p04_hh_ch8_72dpi_p04psdAssetframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch8_p04_hh_ch8_72dpi_p04psdAssetframeLframe(this: Ich8_p04_hh_ch8_72dpi_p04psdAssetframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich8_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich8_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich8_p04Sprite extends Ich8_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich8_p04Text extends Ich8_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich8_p04Polygon extends Array<number> {
}
interface Ich8_p04 {
	readonly bg: Ich8_p04_hh_ch8_72dpi_p04psdAssetbg;
	readonly trunk: Ich8_p04_hh_ch8_72dpi_p04psdAssettrunk;
	readonly foliage: Ich8_p04_hh_ch8_72dpi_p04psdAssetfoliage;
	readonly lamb: Ich8_p04_hh_ch8_72dpi_p04psdAssetlamb;
	readonly frameRight: Ich8_p04_hh_ch8_72dpi_p04psdAssetframeRframe;
	readonly frameLeft: Ich8_p04_hh_ch8_72dpi_p04psdAssetframeLframe;
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssetbg extends Ich8_p04Sprite {
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssettrunk extends Ich8_p04Sprite {
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssetfoliage extends Ich8_p04Sprite {
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssetlamb extends Ich8_p04Sprite {
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssetframeRframe extends Ich8_p04Sprite {
}
interface Ich8_p04_hh_ch8_72dpi_p04psdAssetframeLframe extends Ich8_p04Sprite {
}
